// App.js
import { React, useEffect, useState } from 'react';
import { ChakraProvider, Box } from '@chakra-ui/react';
import Scatter3DPlot from 'components/charts/Scatter3DPlot';
import axios from 'axios';

const AIVRMTriadPlot = () => {
  // Sample data, replace with your actual data source
  const [assetCriticality, setAssetCriticality] = useState([]);
  const [assetVulnerability, setAssetVulnerability] = useState([]);
  const [businessImpact, setBusinessImpact] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [plotData, setPlotData] = useState([null])

  useEffect(() => {
    const uri = process.env.REACT_APP_AWS_FLASK_BASE_URI + "/compute_results";
    console.log(uri);
    const data = {
      "api_key": process.env.REACT_APP_AWS_FLASK_API_KEY
    }
    axios.post(uri, data)
      .then(response => {
        console.log(response.data);
        const assetCriticalityData = response.data.map(item => item.log_data.asset_criticality_score);
        const assetVulnerabilityData = response.data.map(item => item.cvss_base_score);
        const businessImpactData = response.data.map(item => item.log_data.asset_revenue_impacted_per_outage);

        setAssetCriticality(assetCriticalityData);
        setAssetVulnerability(assetVulnerabilityData);
        setBusinessImpact(businessImpactData);

        // Ensure all arrays are the same length for accurate mapping
        if (assetCriticalityData.length !== assetVulnerabilityData.length || 
            assetCriticalityData.length !== businessImpactData.length) {
        throw new Error("All data arrays must have the same length");
        }

        // Format data into the desired structure
        const plotDataFormatted = assetCriticalityData.map((criticality, index) => ({
            criticality,
            vulnerability: assetVulnerabilityData[index],
            impact: businessImpactData[index],
        }));

        console.log("Plot data formatted", plotDataFormatted);
        setPlotData(plotDataFormatted);
        setLoading(false);
      })
      .catch(error => {
        console.error("There was an error fetching CVEs - Settings page!", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data: {error.message}</p>;

  return (
    <ChakraProvider>
      <Box p={5}>
        <Scatter3DPlot data={plotData} />
      </Box>
    </ChakraProvider>
  );
};

export default AIVRMTriadPlot;
